module.exports = __webpack_public_path__ + "static/media/134-zoom in.78cf993c.svg";